import React from 'react';

const VerifyDialog = ({
  open,
  title,
  message,
  warning,
  onConfirm,
  onCancel,
  children,
  confirmDisabled = false,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
        <h2 className="text-xl font-bold text-candy-primary mb-4">{title}</h2>

        {/* Warning Box (optional) */}
        {warning && (
          <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded mb-4 text-sm font-semibold flex items-center justify-center">
            {warning}
          </div>
        )}

        {/* Main Message */}
        <p className="text-gray-700 mb-6">{message}</p>

        {children}

        {/* Confirm / Cancel Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={confirmDisabled}
            className={`px-4 py-2 text-white rounded ${confirmDisabled ? 'bg-red-300 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyDialog;
